import { IConfiguration, LocationType, Maybe } from 'src/types/graphql'
import { isAvailabilityClaimable } from 'src/utils/availabilityFreshness'

/** Visits (30-day unique sessions) below this never render the visits pill —
 * «2 visitas» reads as weak, not as demand. Same floor the chatbot uses for
 * its DEMAND line (LangGraphAgent/utils/messageUtils.ts). */
export const MIN_VISITS_TO_SHOW = 5

export const getActiveScarcityCount = (
  config: IConfiguration,
  isBrokerMode: boolean,
  inventoryIsFresh: Maybe<boolean> | undefined
) => {
  const { availability, watchingCount, locationType } = config
  const isParking = locationType === LocationType.Parking

  /**
   * Scarcity when 1–3 spaces are available (not parking, not broker mode) AND
   * the count is one we can stand behind — platform-kept on SpotMe Now, or
   * confirmed by the host within 45 days off-platform. A missing
   * availability is NOT 0: it used to print «Quedan 0».
   */
  const scarcityCount = availability ?? 0
  const showScarcity =
    !isParking &&
    !isBrokerMode &&
    typeof availability === 'number' &&
    availability >= 1 &&
    availability <= 3 &&
    isAvailabilityClaimable(config, inventoryIsFresh)

  /**
   * `watchingCount` is unique VISIT sessions over the last 30 days (server
   * HostMetricsComputer), not people watching now — the copy says so.
   */
  const showWatching = (watchingCount ?? 0) >= MIN_VISITS_TO_SHOW

  return { scarcityCount, showScarcity, watchingCount, showWatching }
}
